<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
    <v-container class="text-center">
      <v-row>
        <v-col cols="12">
          <v-text-field
            filled
            data-cy="FormTwilioNumber-number"
            :label="$$t('number')"
            v-model="localTwilioNumber.number"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            filled
            data-cy="FormTwilioNumber-country"
            :label="$$t('country')"
            v-model="localTwilioNumber.country"
          />
        </v-col>
      </v-row>
      <div class="d-flex justify-end mb-6">
        <v-btn
          color="default"
          outlined
          class="ml-4 btn-cancel"
          @click="cancel"
          data-cy="FormTwilioNumber-button-cancel">
          {{ $t('common.buttons.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          class="ml-4"
          :loading="isSaving"
          data-cy="FormTwilioNumber-button-save">
          {{ $t('common.buttons.save') }}
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormTwilioNumber',
  module: 'Candidates',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    TwilioNumber: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localTwilioNumber
      */
      localTwilioNumber: {},
    };
  },
  watch: {
    TwilioNumber() {
      this.localTwilioNumber = this.TwilioNumber;
    },
  },
  created() {
    this.localTwilioNumber = this.TwilioNumber;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localTwilioNumber);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormTwilioNumber example

'''js
<FormTwilioNumber :TwilioNumber="TwilioNumber" />
'''
</docs>
